import { useEffect, useState } from "react";

// Returns live content from /api/content, falling back to the bundled
// default array when the API is unreachable or empty (e.g. before KV is set up).
export default function useContent(type, fallback) {
  const [items, setItems] = useState(fallback);

  useEffect(() => {
    let alive = true;
    fetch(`/api/content?type=${type}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (
          alive &&
          data &&
          Array.isArray(data.items) &&
          data.items.length > 0
        ) {
          setItems(data.items);
        }
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [type]);

  return items;
}
